import { SyncOperationText } from "@/components/sync/sync-operation-text";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { SyncErrorHandlingType } from "@/store/sync/operations/errors/SyncError";
import { IUpdateCollectionAclViaEmailAddressOperation } from "@/store/sync/operations/types";
import { SyncCustomErrorData, SyncOperationKind } from "@/store/sync/types";

export class UpdateCollectionAclViaEmailAddressOperation extends BaseSyncOperation<IUpdateCollectionAclViaEmailAddressOperation> {
  get operationKind(): SyncOperationKind {
    return "UPDATE_COLLECTION_ACL_VIA_EMAIL_ADDRESS";
  }

  get successToastMessage() {
    return <>Updating access to {this.mediumTitle}...</>;
  }

  get title() {
    return this.store.collections.get(this.payload.id)?.label;
  }

  get mediumTitle() {
    return <SyncOperationText>{this.title}</SyncOperationText>;
  }

  handleInvalidError(_errorData: SyncCustomErrorData) {
    this.triggerToast(
      <>
        Access to {this.mediumTitle} could not be updated. If this error continues, please contact
        support.
      </>
    );
  }

  handlePermissionDeniedError(_errorData: SyncCustomErrorData) {
    this.triggerToast(
      <>
        You do not have permissions to update access to {this.mediumTitle}. Please contact the note
        owner.
      </>
    );
  }

  handleUnknownError(_errorData: SyncCustomErrorData) {
    this.triggerToast(
      <>
        Access to {this.mediumTitle} could not be updated. If this error continues, please contact
        support.
      </>,
      SyncErrorHandlingType.RetryWithLimit
    );
  }

  async triggerRecompute() {
    this.store.collections.recompute(this.payload.id);
  }
}
